import { cloneDeep } from "lodash";
import { supabase } from "../supabaseClient";
import axios from "axios";

//*events-Main-Page
async function addEvent(event) {
  event.created_at = Date.now();
  const { data, error } = await supabase.from("Events").insert(event);
  if (data) return data;
  else throw error;
}

async function getAllotmentPaymentByUnit(inventoryMergeId, unitId) {
  if (inventoryMergeId) {
    const { data, count, error } = await supabase
      .from("AllotmentPayment")
      .select(
        "*, leadId(leadId, personId(name, email, contactNumber), leadDisplayId, userId(name)), userId(name)",
        { count: "exact" }
      )
      .eq("inventoryMergedId", inventoryMergeId)
      // ! vedashree changes for allotments ====> no need of this clause
      // !vedashree changes ==> this clause needed as multiple released allotments for same unit (22 May,2023)

      .in("status", [
        "On Hold",
        "Payment Pending",
        "Partial Payment Done",
        "Payment Complete",
      ]);
    // .select('*, leadId(leadId, personId(name, email, contactNumber), leadDisplayId)', { count: 'exact' }).eq('inventoryMergedId', inventoryMergeId).eq('status', 'On Hold')
    if (data) return { data, count };
    else throw error;
  } else {
    const { data, count, error } = await supabase
      .from("AllotmentPayment")
      .select(
        "*, leadId(leadId, personId(name, email, contactNumber), leadDisplayId, userId(name)), userId(name)",
        { count: "exact" }
      )
      .eq("unitId", unitId)
      // ! vedashree changes for allotments ====> no need of this clause
      // !vedashree changes ==> this clause needed as multiple released allotments for same unit (22 May,2023)
      .in("status", [
        "On Hold",
        "Payment Pending",
        "Partial Payment Done",
        "Payment Complete",
      ]);
    // .eq('status', 'On Hold')
    if (data) return { data, count };
    else throw error;
  }
}

async function getEventLaunch(userId, loggedInUser) {
  if (
    !JSON.parse(localStorage.getItem("user")).roleId.accessibleTabs.Event[
    "Show Events"
    ] ||
    JSON.parse(localStorage.getItem("user")).roleId.accessibleTabs.Event[
      "Show Events"
    ].show === "Assinged Users"
  ) {
    let query = supabase
      .from("LaunchSalesRelations")
      .select("*,launchId(*,eventId(*))");
    // if(loggedInUser.roleId.level!==1){
    query = query.eq("userId", userId);
    const { data, count, error } = await query;
    if (data) return { data, count };
    else throw error;
  } else {
    let query = supabase.from("Events").select("*");
    const { data, count, error } = await query;
    if (data) return { data, count };
    else throw error;
  }
}

async function getEventLaunchAssignToken(userId, loggedInUser) {
  let query = supabase
    .from("LaunchSalesRelations")
    .select("*,launchId(*,eventId(*))");
  if (
    !JSON.parse(localStorage.getItem("user")).roleId.accessibleTabs.Event[
    "Show Events"
    ] ||
    JSON.parse(localStorage.getItem("user")).roleId.accessibleTabs.Event[
      "Show Events"
    ].show === "Assinged Users"
  ) {
    query = query.eq("userId", userId);
  }
  const { data, count, error } = await query;
  if (data) return { data, count };
  else throw error;
}
async function getAllEvents(filter, search, from, to) {
  // launchid
  let query;
  // if (filter !== 'All' && search !== '') {
  //     console.log(1);
  //     query = supabase
  //         .from('Events')
  //         .select('*', { count: 'exact' }).order('created_at', { ascending: false })
  //         .ilike('status', filter)
  //         .ilike('title', `%${search}%`)
  //         // .range(from, to);
  // } else if (filter === 'All' && search !== '') {
  //     console.log(2);
  //     query = supabase
  //         .from('Events')
  //         .select('*', { count: 'exact' }).order('created_at', { ascending: false })
  //         .ilike('title', `%${search}%`)
  //         // .range(from, to);
  // } else if (filter !== 'All' && search === '') {
  //     console.log(3);
  //     query = supabase
  //         .from('Events')
  //         .select('*', { count: 'exact' }).order('created_at', { ascending: false })
  //         .ilike('status', filter)
  //         // .range(from, to);
  // } else {
  query = supabase
    .from("Events")
    .select("*", { count: "exact" })
    .order("created_at", { ascending: false });
  // .range(from, to);
  // }
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function uploadEventBannerImg(name, file) {
  const { data, error } = await supabase.storage
    .from("eventbannerimages")
    .upload(`${name}.webp`, file, {
      upsert: true,
    });
  if (data) return data;
  else throw error;
}

async function updateEvent(id, obj) {
  let newobj = cloneDeep(obj);
  newobj.last_updated_at = Date.now();
  const { data, error } = await supabase
    .from("Events")
    .update(newobj)
    .eq("eventId", id);
  if (data) return data;
  else throw error;
}
async function startExpirePreselectCronJob(eventId, eventTokenId, launchId) {
  axios
    .post(process.env.REACT_APP_PAYMENT_LINK_URL + "units/startCron", {
      eventId,
      eventTokenId,
      launchId,
      // ! mode?
    })
    .then((resp) => { })
    .catch((err) => {
      console.log("err: ", err);
    });
}
async function getEvent(id) {
  const { data, error } = await supabase
    .from("Events")
    .select("*,tokensRepeatedEventId(*)")
    .eq("eventId", id);
  if (data) return data;
  else throw error;
}

async function getLaunchWise(id) {
  const { data, error } = await supabase
    .from("Launches")
    .select("*")
    .eq("eventId", id);
  if (data) return data;
  else throw error;
}

async function getLaunchDetails(id) {
  let query;
  query = supabase.from("Launches").select("*");
  if (id === "All") {
    const launchIds = JSON.parse(sessionStorage.getItem("selectedLaunches"));
    query = query.in("launchId", launchIds);
  } else {
    query = query.eq("launchId", id);
  }
  // const { data, error } = await supabase
  //   .from("Launches")
  //   .select("*")
  //   .eq("launchId", id);
  const { data, error } = await query;
  if (data) return data;
  else throw error;
}

//*Events-Site-Visit
async function getAllSiteVisitByEventId(
  eventId,
  from,
  to,
  search,
  drpDownSelectedVal,
  selectedLaunch,
  selectedCp,
  selectedSales,
  selectDates,
  selectedDates
) {
  if (search === undefined) {
    search = null;
  }
  const EventSiteVisitFilters = {
    "Name Ascending": {
      key: "leadname",
      isAscending: true,
    },
    "Name Descending": {
      key: "leadname",
      isAscending: false,
    },
    "Oldest First": {
      key: "sitevisitdate",
      isAscending: true,
    },
    "Latest First": {
      key: "sitevisitdate",
      isAscending: false,
    },
  };
  var query;
  query = supabase
    .rpc("sitevisitsofleadsforevent", { pid: eventId }, { count: "exact" })
    .order(EventSiteVisitFilters[drpDownSelectedVal].key, {
      ascending: EventSiteVisitFilters[drpDownSelectedVal].isAscending,
    })
    .range(from, to);

  if (search !== null || search !== "" || search !== undefined) {
    search = search.replace(/\s\s+/g, " ");
    query = query.ilike("leadname", `%${search}%`);
  }

  // if (selectedLaunch.length !== 0) {
  //   console.log(selectedLaunch);
  //   query = query.in('launchid', selectedLaunch);
  // }

  if (selectedCp.length !== 0) {
    query = query.in("cpid", selectedCp);
  }

  if (selectedSales.length !== 0) {
    query = query.in("userid", selectedSales);
  }

  if (selectedDates !== null) {
    query = query
      .gte("sitevisitdate", new Date(selectDates[0].value).getTime())
      .lte("sitevisitdate", new Date(selectDates[1].value).getTime());
  }

  const { data, count, error } = await query;
  if (data) return { data, count };
  else throw error;
}

//*Events-Direct-allotment

async function AutoReleaseUnits(body) {
  return new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_PAYMENT_LINK_URL + "units/updateStatus", body)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
async function getLaunches(eventId, search, from, to, drpDownSelectedVal) {
  const loggedInUserId = JSON.parse(localStorage.getItem("user"))?.userId;
  if (search === undefined) {
    search = null;
  }

  const LaunchesFilters = {
    "Name Ascending": {
      key: "title",
      isAscending: true,
    },
    "Name Descending": {
      key: "title",
      isAscending: false,
    },
    "Oldest First": {
      key: "last_updated_at",
      isAscending: true,
    },
    "Latest First": {
      key: "last_updated_at",
      isAscending: false,
    },
  };
  var query;
  query = supabase
    .from("Launches")
    // .select('* , Projects(projectId)', { count: 'exact' })
    .select("* , Projects(projectId), LaunchSalesRelations!left(*)", {
      count: "exact",
    })
    .order(LaunchesFilters[drpDownSelectedVal].key, {
      ascending: LaunchesFilters[drpDownSelectedVal].isAscending,
    })
    .eq("eventId", eventId)
    .in("LaunchSalesRelations.userId", [loggedInUserId]);
  // .range(from, to);

  if (search !== null) {
    search = search.replace(/\s\s+/g, " ");
    query = query.ilike("title", `%${search}%`);
  }

  const { data, count, error } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getEventByEventName(eventId) {
  const { data, error } = await supabase
    .from("Events")
    .select("*")
    .eq("eventId", eventId);
  if (data) return data;
  else throw error;
}

async function getAllUnitInterests(unitId, from, to) {
  const { data, error, count } = await supabase
    .from("UnitInterests")
    .select("* , leadId(* , personId(*) , userId(*)) , unitId(*)", {
      count: "exact",
    })
    .eq("unitId", unitId)
    .range(from, to);
  if (data) return { data, count };
  else throw error;
}

async function getEventDetailsByEventName(title) {
  const { data, error, count } = await supabase
    .from("Events")
    .select("*", { count: "exact" })
    .eq("title", title);
  if (data) return { data, count };
  else throw error;
}

async function AddUnitInterest(obj) {
  const { data, error } = await supabase.from("UnitInterests").insert(obj);
  if (data) return data;
  else throw error;
}

async function getUnitStatus(unitId) {
  const { data, error } = await supabase
    .from("Inventory")
    .select("*, InventoryStatus(*)")
    .eq("unitId", unitId);
  if (data) return data;
  else throw error;
}
async function UpdateUnitStatus(StatusId, unitId, leadId, UnitHoldTime) {
  const { data, error } = await supabase
    .from("Inventory")
    .update({
      inventoryStatusId: StatusId,
      leadId: leadId,
      unitHoldTime: UnitHoldTime,
    })
    .eq("unitId", unitId);
  if (data) return data;
  else throw error;
}

async function UpdateTokenStatus(paymentId) {
  const { data, error } = await supabase
    .from("EventTokenLeadRelations")
    .update({
      status: "alloted",
    })
    .eq("paymentId", paymentId);
  if (data) return data;
  else throw error;
}

async function updateLeadStatusForAllotment(
  leadId,
  status,
  AllotmentPaymentId,
  TokenId
) {
  const { data, error } = await supabase
    .from("LeadStatus")
    .update({
      status: status,
      last_updated_at: Date.now(),
      allotmentPaymentId: AllotmentPaymentId,
      tokenId: TokenId,
    })
    .eq("leadId", leadId)
    .single();
  if (data) return data;
  else throw error;
}

async function getLeadDetails(leadId, launchId, unitId) {
  const { data, error, count } = await supabase
    .from("UnitInterests")
    .select("*", { count: "exact" })
    .eq("leadId", leadId)
    .eq("launchId", launchId)
    .eq("unitId", unitId);
  if (data) return { data, count };
  else throw error;
}

async function getInventoryStatus() {
  const { data, error, count } = await supabase
    .from("InventoryStatus")
    .select("*", { count: "exact" })
    .eq("status", "On Hold");
  if (data) return { data, count };
  else throw error;
}

async function getProjectPricingByUnitId(wingName, projectId) {
  const { data, error, count } = await supabase
    .from("ProjectPricing")
    .select("*", { count: "exact" })
    .eq("wingId", wingName)
    .eq("projectId", projectId);
  // .eq("inventoryTypeId", unitType)
  // .lte("startDateTime", Date.now())
  // .gte("endDateTime" , Date.now());
  if (data) return { data, count };
  else throw error;
}
async function getAllLeadNameForToken(eventId) {
  let query = supabase
    .from("EventTokenLeadRelations")
    .select("*,leadId(*,personId(*),LeadStatus!left(*))", { count: "exact" })
    .eq("eventId", eventId)
    .in("status", ["active", "alloted", "adjusted"])
    // ! vedashree changes ==> for prerequisite tokens (priority pass flow)
    .eq("isPrerequisiteUsed", false)
    // .in('leadId.LeadStatus.status', ['Token Payment Complete','Checkpoint One Cleared','Checkpoint Two Cleared'])
    .order("last_updated_at", { ascending: false });
  //!! Sarita changes
  if (
    JSON.parse(localStorage.getItem("user")) &&
    JSON.parse(localStorage.getItem("user")).roleId.title !== "CRM"
  ) {
    query = query.in(
      "leadId.userId",
      JSON.parse(localStorage.getItem("teamIds"))
    );
  }

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getLeadForToken(eventId, LeadId) {
  let query = supabase
    .from("EventTokenLeadRelations")
    .select("*,leadId(*,personId(*),LeadStatus!left(*))", { count: "exact" })
    .eq("eventId", eventId)
    .in("status", ["active", "alloted", "adjusted"])
    // .in('leadId.LeadStatus.status', ['Token Payment Complete','Checkpoint One Cleared','Checkpoint Two Cleared'])
    .eq("leadId.leadDisplayId", LeadId)
    .order("created_at", { ascending: false });

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getAllotedLeadFromPaymentsTable(unitId) {
  let query = supabase
    .from("AllotmentPayment")
    .select("*,leadId(*,personId(*),LeadStatus!left(*)) , paymentId(*)", {
      count: "exact",
    })
    .eq("unitId", unitId)
    .order("created_at", { ascending: false });

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function InsertIntoAllotmentTable(obj) {
  let query = supabase
    .from("AllotmentPayment")
    .insert(obj)
    .order("created_at", { ascending: false });

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function DeleteTokenTransaction(transactionId) {
  let query = supabase
    .from("TokenTransactions")
    .delete()
    .eq("transactionId", transactionId);
  const { data, error } = await query;
  if (data) return data;
  else throw error;
}

async function allotUnit(
  AllotmentDetails,
  UnitStatus,
  paymentId,
  eventId,
  UnitData,
  loggedInUser,
  leadStatus,
  preselectDetails,
  leadname,
  leadcontactnumber,
) {
  const postBody = {
    AllotmentDetails,
    UnitStatus,
    paymentId,
    eventId,
    UnitData,
    loggedInUser,
    leadStatus,
    preselectDetails,
    leadname,
    leadcontactnumber
  };
  return await axios.post(
    process.env.REACT_APP_PAYMENT_LINK_URL + "bookings/allotUnit",
    postBody
  );
  // return await axios.post("http://192.168.2.113:8000/" + 'bookings/allotUnit', postBody);
}

async function getAllotmentPayment(allotmentPaymentId) {
  const { data, error, count } = await supabase
    .from("AllotmentPayment")
    .select("*", { count: "exact" })
    .eq("allotmentPaymentId", allotmentPaymentId);
  if (data) return { data, count };
  else throw error;
}
async function getLeadFromAllotment(unitId, leadId) {
  const { data, error, count } = await supabase
    .from("AllotmentPayment")
    .select("*", { count: "exact" })
    .eq("unitId", unitId)
    .eq("leadId", leadId);
  if (data) return { data, count };
  else throw error;
}

async function getLeadFromMergedAllotment(inventoryMergedId, leadId) {
  const { data, error, count } = await supabase
    .from("AllotmentPayment")
    .select("*", { count: "exact" })
    .eq("inventoryMergedId", inventoryMergedId)
    .eq("leadId", leadId);
  if (data) return { data, count };
  else throw error;
}

async function getLeadData(LeadId) {
  const { data, error, count } = await supabase
    .from("Leads")
    .select("* , personId(*)", { count: "exact" })
    .eq("leadDisplayId", LeadId);
  if (data) return { data, count };
  else throw error;
}

async function getLaunchInventoryRelations(launchId) {
  const { data, error, count } = await supabase
    .rpc("getwingsbylaunch", { launchid: launchId })
    .select("*", { count: "exact" });
  if (data) return { data, count };
  else throw error;
}

async function getUnitsOfLaunches(launchId) {
  const { data, error, count } = await supabase
    .from("LaunchInventoryRelations")
    .select("* , unitId(* , inventoryStatusId(*)) ", { count: "exact" })
    .eq("launchId", launchId);
  if (data) return { data, count };
  else throw error;
}

async function getUnitsOfLaunchesByWingId(launchId, wingId) {
  const { data, error, count } = await supabase
    .from("LaunchInventoryRelations")
    .select(
      "* , unitId(* , inventoryStatusId(*) , inventoryTypeId(*) , leadId(* , userId(*)))  , mergeId(*) ",
      { count: "exact" }
    )
    .eq("launchId", launchId)
    .eq("wingId", wingId);

  if (data) return { data, count };
  else throw error;
}

async function RemoveUnitFromAllotment(unitId) {
  let query = supabase.from("AllotmentPayment").delete().eq("unitId", unitId);
  const { data, error } = await query;
  if (data) return data;
  else throw error;
}

async function UpdateLeadToPreviousStatus(leadId, allotmentPaymentId) {
  let query = supabase
    .from("LeadLogs")
    .select("*", { count: "exact" })
    .eq("leadId", leadId)
    .eq("allotmentPaymentId", allotmentPaymentId)
    .order("last_updated_at", { ascending: false });
  const { data, error } = await query;
  if (data) return data;
  else throw error;
}

//*Events-Preselect
async function getPreSelectLaunchInventoryRelations(TokenId) {
  const { data, error, count } = await supabase
    .rpc("getwingsbytoken", { tokenid: TokenId })
    .select("*", { count: "exact" });
  if (data) return { data, count };
  else throw error;
}

async function getPreSelectWings(TokenId, launchId) {
  const { data, error, count } = await supabase
    .rpc("getwingsbylaunchandtoken", { tokenid: TokenId, launchid: launchId })
    .select("*", { count: "exact" });
  if (data) return { data, count };
  else throw error;
}

async function getUnitsOfPreselect(launchId) {
  const { data, error, count } = await supabase
    .from("PreselectInventoryRelations")
    .select(
      "* , unitId(* , inventoryStatusId(*) , inventoryMergeId(*) , inventoryTypeId(*))",
      { count: "exact" }
    )
    .eq("launchId", launchId);
  if (data) return { data, count };
  else throw error;
}

async function getUnitsOfPreselectByWingName(
  launchId,
  wingId,
  unitTypeFilter,
  eventTokenId
) {
  const { data, error, count } = await supabase
    .from("PreselectInventoryRelations")
    .select(
      "* , unitId(* , inventoryStatusId(*) , inventoryMergeId(*) , inventoryTypeId(*) ) ,mergeId(*)",
      { count: "exact" }
    )
    .eq("launchId", launchId)
    .eq("wingId", wingId)
    .eq("unitId.inventoryTypeId.inventoryTypeId", unitTypeFilter)
    .eq("eventTokenId", eventTokenId);
  if (data) return { data, count };
  else throw error;
}

async function getPreSelectLaunches(TokenId) {
  const loggedInUserId = JSON.parse(localStorage.getItem("user"))?.userId;
  const { data, error, count } = await supabase
    .rpc("getlaunchesbytoken", {
      tokenid: TokenId,
      usersarray: [loggedInUserId],
    })
    .select("*", { count: "exact" });
  if (data) return { data, count };
  else throw error;
}

async function AddPreSelectData(obj) {
  const { data, error } = await supabase
    .from("EventTokenLeadRelations")
    .insert(obj);
  if (data) return data;
  else throw error;
}

async function updatePreSelectData(paymentId, obj) {
  const { data, error } = await supabase
    .from("EventTokenLeadRelations")
    .update(obj)
    .eq("paymentId", paymentId);
  if (data) return data;
  else throw error;
}

async function checkEventTokenLeadRelation(paymentId) {
  const { data, error } = await supabase
    .from("EventTokenLeadRelations")
    .select("*")
    .eq("paymentId", paymentId);
  if (data) return data;
  else throw error;
}

//*Events-Cp&Sales
async function getAllCpForEvents(eventId, from, to) {
  const { data, error, count } = await supabase
    .from("Launches")
    .select(
      "* , LaunchCpRelations!left(cpId , CP!left(* , CpContactPerson(*)))",
      { count: "exact" }
    )
    .eq("eventId", eventId)
    .range(from, to);
  if (data) return { data, count };
  else throw error;
}

async function getEventsToRepeat() {
  const { data, error, count } = await supabase.rpc("geteventstorepeat");
  if (data) return { data, count };
  else throw error;
}

async function getAllUsersForEvents(eventId, from, to) {
  const { data, error, count } = await supabase
    .from("Launches")
    .select("* , LaunchSalesRelations!left(userId , Users!left(*))", {
      count: "exact",
    })
    .eq("eventId", eventId)
    .range(from, to);
  if (data) return { data, count };
  else throw error;
}

//*Events-Token-holders

async function getAllTokenHoldersFromRpc(
  eventId,
  from,
  to,
  sendTabValue,
  search,
  drpDownSelectedVal,
  selectDates,
  selectedDates,
  selectedCP,
  selectedSales,
  selectedProjects,
  selectedLeadQuality,
  selectedStatus,
  loggedInUser
) {
  const TabFilters = {
    "Name Ascending": {
      key: "leadname",
      isAscending: true,
    },
    "Name Descending": {
      key: "leadname",
      isAscending: false,
    },
    "Oldest First": {
      key: "last_updated_at",
      isAscending: true,
    },
    "Latest First": {
      key: "last_updated_at",
      isAscending: false,
    },
  };

  var query;
  query = supabase
    .rpc("tokenholders", {}, { count: "exact" })
    .order(TabFilters[drpDownSelectedVal].key, {
      ascending: TabFilters[drpDownSelectedVal].isAscending,
    })
    .range(from, to);

  if (sendTabValue === "Token") {
    query = query = query.in("leadstatus", [
      "Token Payment Pending",
      "Token Partial Payment Done",
      "Token Payment Complete",
      "Token Refund Requested",
      "Token Refunded",
      "Token Refund Request Rejected",
      "Token Payment Not Done",
    ]);
  } else if (sendTabValue === "Allotment") {
    query = query = query.in("leadstatus", [
      "Allotment Done",
      "Unit On Hold",
      "Allotment Partial Payment Done",
      "Allotment Payment Pending",
      "Allotment Payment Complete",
      "PreSelect Confirmation Pending",
      "PreSelect Price Confirmation Pending",
      "PreSelect Unit On Hold",
      "PreSelect Payment Pending",
      "Preselect not confirmed",
      "Preselect payment not done",
      "Change Unit Requested",
      "Change Unit Confirmation Pending",
      "Change Unit Confirmation Rejected",
      "Change Unit Confirmed",
      "Change Unit Rejected",
      "Requested Unit Cancellation",
      "Cancel Unit Confirmation Pending",
      "Cancel Unit Confirmation Rejected",
      "Cancel Unit Rejected",
      "Cancel Unit Confirmed",
    ]);
  } else if (sendTabValue === "Agreement Done") {
    query = query.in("leadstatus", ["Agreement Done"]).range(from, to);
  } else if (sendTabValue === "Checkpoint One Cleared") {
    query = query.in("leadstatus", ["Checkpoint One Cleared"]).range(from, to);
  } else if (sendTabValue === "Checkpoint Two Cleared") {
    query = query.in("leadstatus", ["Checkpoint Two Cleared"]).range(from, to);
  }

  if (search !== null || search !== "" || search !== undefined) {
    search = search.replace(/\s\s+/g, " ");
    query = query.ilike("leadname", `%${search}%`);
  }
  if (selectedSales.length !== 0) {
    query = query.in("salesid", selectedSales);
  }
  if (selectedProjects.length !== 0) {
    query = query.in("projectname", selectedProjects);
  }
  if (selectedStatus.length !== 0) {
    query = query.in("leadstatus", selectedStatus);
  }
  if (selectedLeadQuality.length !== 0) {
    query = query.in("leadresponse", selectedLeadQuality);
  }
  if (selectedCP.length !== 0) {
    query = query.in("cpid", selectedCP);
  }
  if (selectedDates !== null) {
    query = query
      .gte("created_at", new Date(selectDates[0].value).getTime())
      .lte("created_at", new Date(selectDates[1].value).getTime());
  }
  if (loggedInUser?.roleId?.level !== 1) {
    const teamIds = JSON.parse(localStorage.getItem("teamIds"));
    console.log("teamIds", teamIds);
    query = query.in("salesid", teamIds);
  }
  const { data, count, error } = await query.eq("eventid", eventId);
  if (data) return { data, count };
  else throw error;
}

async function getAllotmentDataForTokenHolders(eventId, leadId) {
  let query = supabase
    .rpc("allotmentfilter", {}, { count: "exact" })
    .eq("eventid", eventId)
    .eq("leadid", leadId);

  const { data, count, error } = await query;
  if (data) return { data, count };
  else throw error;
}

//*Events-Cancel-unit-requests
// async function getAllEventsCancelUnitRequests(
//   page,
//   search,
//   filterBy,
//   userId,
//   repriceUnit,
//   checked,
//   selectedDate,
//   cancellationsSubTabs
// ) {
//   let all_cpId = [];
//   let all_projectId = [];
//   let all_salesRepresentativeId = [];
//   let all_status = [];
//   let all_pendingUserId = [];
//   let jsonParse;

//   // ,requestPendingWithUserId(*),requestPendingWithRoleId(*)
//   const loggedInUser = JSON.parse(localStorage.getItem("user"));
//   const limit = 10;
//   const fromCount = page * limit;
//   const toCount = page * limit + (limit - 1);
//   let query = supabase
//     .rpc("cancellationfilter", {}, { count: "exact" })
//     .order(
//       filterBy.includes("Name")
//         ? "leadname"
//         : filterBy.includes("Unit")
//           ? "unitno"
//           : "last_updated_at",
//       {
//         ascending:
//           filterBy.includes("Oldest") || filterBy.includes("Ascending")
//             ? true
//             : false,
//       }
//     );
//   if (search === "") {
//     query = query.range(fromCount, toCount);
//   }
//   // .range(page === 0 ? page * 10 : page * 10 + 1, page === 0 ? ((page + 1) * 10) : (page * 10 + 10))
//   // if (loggedInUser?.roleId?.level !== 1) {
//   //   query = query.eq('requestPendingWithUserId', userId)
//   // }
//   if (loggedInUser?.roleId?.level !== 1 && repriceUnit !== null) {
//     if (
//       loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
//         ?.isAccessible
//     ) {
//       // ??under that team only ->show
//       // const teamIds = JSON.parse(localStorage.getItem('teamIds'));
//       // query = query.in('userId', teamIds);
//       // ??This user access is going to be given only to CRM user
//       query = query.is("requestpendingwithuserid", null);
//       if (repriceUnit?.value === "Pending") {
//         query = query.eq("unitpricealreadyupdated", false);
//         query = query.eq("isskipreprice", false);
//       } else {
//         query = query.eq("unitpricealreadyupdated", true);
//       }
//     } else {
//       //  as it is not change.
//       query = query.eq("requestpendingwithuserid", userId);
//     }
//   } else if (loggedInUser?.roleId?.level !== 1 && repriceUnit === null) {
//     query = query.eq("requestpendingwithuserid", userId);
//   } else {
//     if (
//       loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
//         ?.isAccessible &&
//       repriceUnit !== null
//     ) {
//       // ??under that team only ->show
//       // const teamIds = JSON.parse(localStorage.getItem('teamIds'));
//       // query = query.in('userId', teamIds);
//       // ??This user access is going to be given only to CRM user
//       query = query.is("requestpendingwithuserid", null);
//       if (repriceUnit?.value === "Pending") {
//         query = query.eq("unitpricealreadyupdated", false);
//         query = query.eq("isskipreprice", false);
//       } else {
//         query = query.eq("unitpricealreadyupdated", true);
//       }
//     } else {
//       // ! show all cancellation requests
//     }
//   }

//   if (checked && checked.length > 0) {
//     checked.map((item) => {
//       jsonParse = JSON.parse(item);
//       if (jsonParse.filter == "CP") {
//         all_cpId.push(jsonParse.value);
//       } else if (jsonParse.filter == "Projects") {
//         all_projectId.push(jsonParse.value);
//       } else if (jsonParse.filter == "Users") {
//         all_salesRepresentativeId.push(jsonParse.value);
//       } else if (jsonParse.filter == "Pending With") {
//         all_pendingUserId.push(jsonParse.value);
//       } else if (jsonParse.filter == "Status") {
//         all_status.push(jsonParse.value);
//       }
//     });
//   }

//   if (all_cpId.length !== 0) {
//     query = query.in("cpid", all_cpId);
//   }

//   if (
//     selectedDate?.[0]?.value !== "" &&
//     selectedDate?.[1]?.value !== "" &&
//     selectedDate !== undefined
//   ) {
//     query = query
//       .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
//       .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
//   }

//   if (all_salesRepresentativeId.length !== 0) {
//     query = query.in("userid", all_salesRepresentativeId);
//   }

//   if (all_pendingUserId.length !== 0) {
//     query = query.in("requestpendingwithuserid", all_pendingUserId);
//   }

//   if (all_projectId.length !== 0) {
//     if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
//       query = query.in("projectid", all_projectId[0]?.[0]?.["p"]);
//     }

//     if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
//       query = query.in("wingid", all_projectId[0]?.[0]?.["w"]);
//     }

//     if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
//       query = query.in("floorno", all_projectId[0]?.[0]?.["f"]);
//     }
//   }

//   if (all_status.length !== 0) {
//     // let str = [];
//     // if (all_status.includes("Pending")) {
//     //   str.push(`paidamount.eq.0`);
//     // }
//     // if (all_status.includes("Partial")) {
//     //   str.push(`and(paidamount.lt.500000,paidamount.gt.0)`);
//     // }
//     // if (all_status.includes("Complete")) {
//     //   str.push(`paidamount.eq.500000`);
//     // }
//     // if (str.length) query = query.or(str.join(","));
//     if (all_status.includes("Pending")) {
//       query = query.in("status", all_status);
//       query = query.eq("leadconfirmation", "Accepted");
//     } else {
//       query = query.in("status", all_status);
//     }
//   }
//   if (all_status.length === 0) {

//     if (cancellationsSubTabs === "Rejected") {
//       query = query.in("status", ["Rejected"]);
//     } else if (cancellationsSubTabs === "Cancellation") {
//       query = query.in("status", ["Pending"]);
//     } else if (cancellationsSubTabs === "Accepted") {
//       query = query.in("status", ["Accepted"]);
//     }
//   }

//   // if (filterBy.includes("Name")) {
//   //   query = query.order("name", {
//   //     foreignTable: "leadid",
//   //     ascending: filterBy.includes("Ascending") ? true : false,
//   //   });
//   // } else {
//   //   query = query.order("last_updated_at", {
//   //     ascending: filterBy.includes("Oldest") ? true : false,
//   //   });
//   // }
//   if (search && search !== "") {
//     query = query.or(`leadname.ilike.%${search}%,unitno.ilike.%${search}%`);
//   }

//   const { data, count, error } = await query;
//   if (data) return { data, count };
//   else throw error;
// }



async function getAllEventsCancelUnitRequests(
  page,
  search,
  filterBy,
  userId,
  repriceUnit,
  checked,
  selectedDate,
  cancellationsSubTabs
) {
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_status = [];
  let all_pendingUserId = [];
  let jsonParse;

  // ,requestPendingWithUserId(*),requestPendingWithRoleId(*)
  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  const limit = 10;
  const fromCount = page * limit;
  const toCount = page * limit + (limit - 1);
  let query = supabase
    .rpc("cancellationfilter", {}, { count: "exact" })
    .order(
      filterBy.includes("Name")
        ? "leadname"
        : filterBy.includes("Unit")
          ? "unitno"
          : "last_updated_at",
      {
        ascending:
          filterBy.includes("Oldest") || filterBy.includes("Ascending")
            ? true
            : false,
      }
    );
  if (search === "") {
    query = query.range(fromCount, toCount);
  }
  // .range(page === 0 ? page * 10 : page * 10 + 1, page === 0 ? ((page + 1) * 10) : (page * 10 + 10))
  // if (loggedInUser?.roleId?.level !== 1) {
  //   query = query.eq('requestPendingWithUserId', userId)
  // }
  if (loggedInUser?.roleId?.level !== 1 && repriceUnit !== null) {
    if (
      loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
        ?.isAccessible
    ) {
      // ??under that team only ->show
      // const teamIds = JSON.parse(localStorage.getItem('teamIds'));
      // query = query.in('userId', teamIds);
      // ??This user access is going to be given only to CRM user
      query = query.is("requestpendingwithuserid", null);
      if (repriceUnit?.value === "Pending") {
        query = query.eq("unitpricealreadyupdated", false);
        query = query.eq("isskipreprice", false);
      } else {
        query = query.eq("unitpricealreadyupdated", true);
      }
    } else {
      //  as it is not change.
      query = query.eq("requestpendingwithuserid", userId);
    }
  } else if (loggedInUser?.roleId?.level !== 1 && repriceUnit === null) {
    query = query.eq("requestpendingwithuserid", userId);
  } else {
    if (
      loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
        ?.isAccessible &&
      repriceUnit !== null
    ) {
      // ??under that team only ->show
      // const teamIds = JSON.parse(localStorage.getItem('teamIds'));
      // query = query.in('userId', teamIds);
      // ??This user access is going to be given only to CRM user
      query = query.is("requestpendingwithuserid", null);
      if (repriceUnit?.value === "Pending") {
        query = query.eq("unitpricealreadyupdated", false);
        query = query.eq("isskipreprice", false);
      } else {
        query = query.eq("unitpricealreadyupdated", true);
      }
    } else {
      // ! show all cancellation requests
    }
  }

  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "Pending With") {
        all_pendingUserId.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      }
    });
  }

  if (all_cpId.length !== 0) {
    query = query.in("cpid", all_cpId);
  }

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.in("userid", all_salesRepresentativeId);
  }

  if (all_pendingUserId.length !== 0) {
    query = query.in("requestpendingwithuserid", all_pendingUserId);
  }

  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("projectid", all_projectId[0]?.[0]?.["p"]);
    }

    if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
      query = query.in("wingid", all_projectId[0]?.[0]?.["w"]);
    }

    if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
      query = query.in("floorno", all_projectId[0]?.[0]?.["f"]);
    }
  }

  if (all_status.length !== 0) {
    // let str = [];
    // if (all_status.includes("Pending")) {
    //   str.push(`paidamount.eq.0`);
    // }
    // if (all_status.includes("Partial")) {
    //   str.push(`and(paidamount.lt.500000,paidamount.gt.0)`);
    // }
    // if (all_status.includes("Complete")) {
    //   str.push(`paidamount.eq.500000`);
    // }
    // if (str.length) query = query.or(str.join(","));
    if (all_status.includes("Pending")) {
      query = query.in("status", all_status);
      query = query.eq("leadconfirmation", "Accepted");
    } else {
      query = query.in("status", all_status);
    }
  }
  if (all_status.length === 0) {

    if (cancellationsSubTabs === "Rejected") {
      query = query.in("status", ["Rejected"]);
    } else if (cancellationsSubTabs === "Cancellation") {
      query = query.in("status", ["Pending"]);
    } else if (cancellationsSubTabs === "Accepted") {
      query = query.in("status", ["Accepted"]);
    }
  }

  // if (filterBy.includes("Name")) {
  //   query = query.order("name", {
  //     foreignTable: "leadid",
  //     ascending: filterBy.includes("Ascending") ? true : false,
  //   });
  // } else {
  //   query = query.order("last_updated_at", {
  //     ascending: filterBy.includes("Oldest") ? true : false,
  //   });
  // }
  if (search && search !== "") {
    query = query.or(`leadname.ilike.%${search}%,unitno.ilike.%${search}%`);
  }

  // const { data, count, error } = await query;
  // console.log("getAllEventsCancelUnitRequests", data)
  // if (data) return { data, count };
  // else throw error;




  const { data, count, error } = await query;
if (error) throw error;


// if (data && data.length > 0) {
//   const mergedData = [];

//   for (const item of data) {
//     // Only query when IDs are valid
//     if (item.projectid && item.wingid && item.inventorytypeid) {
//       const { data: configData, error: configError } = await supabase
//         .from("projectAdditionalConfiguration")
//         .select("isCommercial")
//         .eq("projectId", item.projectid)
//         .eq("wingId", item.wingid)
//         .eq("inventoryTypeId", item.inventorytypeid)
//         .limit(1); // ✅ avoids PGRST116 even if multiple exist

//       if (configError) {
//         console.error("Supabase error:", configError);
//       }

//       mergedData.push({
//         ...item,
//         isCommercial: configData?.[0]?.isCommercial ?? null,
//       });
//     } else {
//       mergedData.push({ ...item, isCommercial: null });
//     }
//   }

//   return { data: mergedData, count };
// } else {
//   return { data: [], count: 0 };
// }




if (data && data.length > 0) {
  // ✅ STEP 1: collect unique IDs
  const projectIds = [...new Set(data.map(d => d.projectid).filter(Boolean))];

  // ✅ STEP 2: fetch isCommercial/gstPercentage from projectAdditionalConfiguration
  const { data: configData, error: configError } = await supabase
    .from("projectAdditionalConfiguration")
    .select("projectId, wingId, inventoryTypeId, isCommercial, gstPercentage")
    .in("projectId", projectIds);

  if (configError) throw configError;

  // ✅ STEP 3: fetch sdrPercentage & legalCharges from Projects table
  const { data: projectData, error: projectError } = await supabase
    .from("Projects")
    .select("projectId, sdrPercentage, legalCharges")
    .in("projectId", projectIds);

  if (projectError) throw projectError;

  // ✅ STEP 4: create lookup maps
  const configMap = new Map(
    configData.map(c => [
      `${c.projectId}-${c.wingId}-${c.inventoryTypeId}`,
      { isCommercial: c.isCommercial, gstPercentage: c.gstPercentage },
    ])
  );

  const projectMap = new Map(
    projectData.map(p => [
      p.projectId,
      { sdrPercentage: p.sdrPercentage, legalCharges: p.legalCharges },
    ])
  );

  // ✅ STEP 5: merge everything into final data
  const mergedData = data.map(item => {
    const key = `${item.projectid}-${item.wingid}-${item.inventorytypeid}`;
    const projectDetails = projectMap.get(item.projectid) || {};
    const config = configMap.get(key);
    return {
      ...item,
      isCommercial: config?.isCommercial ?? null,
      // Only commercial rows carry a GST % override; non-commercial units
      // keep using the hardcoded 1%/5% GST rule client-side
      gstPercentage: config?.isCommercial ? config?.gstPercentage ?? null : null,
      sdrPercentage: projectDetails.sdrPercentage ?? null,
      legalCharges: projectDetails.legalCharges ?? null,
    };
  });

  console.log("Merged Cancel Unit Requests:", mergedData);
  return { data: mergedData, count };
} else {
  return { data: [], count: 0 };
}



}

async function updateCancelRequestsForSkipReprice(cancelUnitRequestId) {
  const { data, error, count } = await supabase
    .from("CancelUnitRequests")
    .update({
      isSkipReprice: true,
    })
    .eq("cancelUnitRequestId", cancelUnitRequestId);
  if (data) return { data, count };
  else throw error;
}

// ??Update Cancel unit requests
async function updateCancelRequests(
  cancelUnitRequestId,
  status,
  requestPending,
  oldUnitPrice,
  cancellationCharge,
  waveOff,
  payload
) {
  const { data, error, count } = await supabase
    .from("CancelUnitRequests")
    .update({
      status: status,
      requestPendingWithUserId: requestPending.parentId,
      requestPendingWithRoleId: requestPending.roleId,
      last_updated_at: new Date().getTime(),
      oldUnitPrice: oldUnitPrice,
      cancellationCharges: cancellationCharge,
      isWaivedOff: waveOff,
      waivedOffReason: payload?.waivedOffReason,
      waivedOffCancellationCharges: payload?.waivedOffCancellationCharges,
      newCancellationCharges: payload?.newCancellationCharges
    })
    .eq("cancelUnitRequestId", cancelUnitRequestId);
  if (data) return { data, count };
  else throw error;
}
async function updateCancelRequestsForLeadAcceptance(cancelUnitRequestId) {
  const { data, error, count } = await supabase
    .from("CancelUnitRequests")
    .update({
      leadConfirmation: "Accepted",
      last_updated_at: new Date().getTime(),
    })
    .eq("cancelUnitRequestId", cancelUnitRequestId);
  if (data) return { data, count };
  else throw error;
}
async function updateCancelRequestsForRejection(
  cancelUnitRequestId,
  status,
  oldPriceObj,
  requestReject
) {
  const { data, error, count } = await supabase
    .from("CancelUnitRequests")
    .update({
      status: status,
      last_updated_at: new Date().getTime(),
      oldUnitPrice: oldPriceObj,
      requestPendingWithUserId: requestReject?.userId,
      requestPendingWithRoleId: requestReject?.roleId,
    })
    .eq("cancelUnitRequestId", cancelUnitRequestId);
  if (data) return { data, count };
  else throw error;
}
async function updateCancelRequestsForReprice(cancelUnitRequestId, obj) {
  const { data, error, count } = await supabase
    .from("CancelUnitRequests")
    .update(obj)
    .eq("cancelUnitRequestId", cancelUnitRequestId);
  if (data) return { data, count };
  else throw error;
}

async function updateChangeRequestsForReprice(changeUnitRequestId, obj) {
  const { data, error, count } = await supabase
    .from("ChangeUnitRequests")
    .update(obj)
    .eq("changeUnitRequestId", changeUnitRequestId);
  if (data) return { data, count };
  else throw error;
}

async function getAvailableIdInventoryStatus() {
  const { data, error } = await supabase
    .from("InventoryStatus")
    .select("*")
    .eq("status", "Available")
    .single();
  if (data) return { data };
  else throw error;
}
async function updateInventorForCancelUnit(unitId, bsp, gst, sdr, total) {
  let statusId = await getAvailableIdInventoryStatus();
  const { data, error, count } = await supabase
    .from("Inventory")
    .update({
      leadId: null,
      inventoryStatusId: statusId.data.inventoryStatusId,
      BSP: bsp,
      GST: gst,
      SDR: sdr,
      totalCost: total,
    })
    .eq("unitId", unitId);
  if (data) return { data, count };
  else throw error;
}

async function updateInventorStatusWiseForCancelUnit(unitId, obj) {
  if (
    obj.pricingtype === "preselect" &&
    (obj?.preselectconfirmation === "confirmation pending" ||
      obj?.preselectconfirmation === "payment pending")
  ) {
    let statusId = await getAvailableIdInventoryStatus();
    const { data, error, count } = await supabase
      .from("Inventory")
      .update({
        leadId: null,
        inventoryStatusId: statusId.data.inventoryStatusId,
      })
      .eq("unitId", unitId);
    if (data) return { data, count };
    else throw error;
  } else {
    let statusId = await getAvailableIdInventoryStatus();
    const { data, error, count } = await supabase
      .from("Inventory")
      .update({
        leadId: null,
        inventoryStatusId: statusId.data.inventoryStatusId,
        BSP: 0,
        GST: 0,
        SDR: 0,
        totalCost: 0,
      })
      .eq("unitId", unitId);
    if (data) return { data, count };
    else throw error;
  }
}

async function updateInventorStatusWiseForCancelUnitForLeads(unitId, obj) {
  if (
    obj.pricingType === "preselect" &&
    (obj?.preselectConfirmation === "confirmation pending" ||
      obj?.preselectConfirmation === "payment pending")
  ) {
    let statusId = await getAvailableIdInventoryStatus();
    const { data, error, count } = await supabase
      .from("Inventory")
      .update({
        leadId: null,
        inventoryStatusId: statusId.data.inventoryStatusId,
      })
      .eq("unitId", unitId);
    if (data) return { data, count };
    else throw error;
  } else {
    let statusId = await getAvailableIdInventoryStatus();
    const { data, error, count } = await supabase
      .from("Inventory")
      .update({
        leadId: null,
        inventoryStatusId: statusId.data.inventoryStatusId,
        BSP: 0,
        GST: 0,
        SDR: 0,
        totalCost: 0,
      })
      .eq("unitId", unitId);
    if (data) return { data, count };
    else throw error;
  }
}
// **Updating allotment pricing
async function updateAllotmentUnitCost(cancelUnitRequestId, values) {
  const { data, error, count } = await supabase
    .from("CancelUnitRequests")
    .update({ updatedUnitPrice: values })
    .eq("cancelUnitRequestId", cancelUnitRequestId);
  if (data) return { data, count };
  else throw error;
}
// Change Unit requests
async function getAllEventsChangeUnitRequests(
  page,
  search,
  filterBy,
  userId,
  repriceUnit,
  checked,
  selectedDate
) {
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_status = [];
  let jsonParse;
  const limit = 10;
  const fromCount = page * limit;
  const toCount = page * limit + (limit - 1);

  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  let query = supabase
    .rpc("changeunitfilter", {}, { count: "exact" })
    .order(
      filterBy.includes("Name")
        ? "leadname"
        : filterBy.includes("Unit")
          ? "unitno"
          : "last_updated_at",
      {
        ascending:
          filterBy.includes("Oldest") || filterBy.includes("Ascending")
            ? true
            : false,
      }
    );

  if (search === "") {
    query = query.range(fromCount, toCount);
  }

  if (search && search !== "") {
    query = query.or(`leadname.ilike.%${search}%,currentunitno.ilike.%${search}%,requestedunitno.ilike.%${search}%`);
  }

  if (loggedInUser?.roleId?.level !== 1 && repriceUnit !== null) {
    if (
      loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
        ?.isAccessible
    ) {
      // ??under that team only ->show
      // const teamIds = JSON.parse(localStorage.getItem('teamIds'));
      // query = query.in('userId', teamIds);
      // ??This user access is going to be given only to CRM user
      query = query.is("requestpendingwithuserid", null);
      if (repriceUnit?.value === "Pending") {
        query = query.eq("unitpricealreadyupdated", false);
      } else {
        query = query.eq("unitpricealreadyupdated", true);
      }
    } else {
      query = query.eq("requestpendingwithuserid", userId);
    }
  } else {
    if (
      loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Reprice Unit"]
        ?.isAccessible &&
      repriceUnit !== null
    ) {
      // ??under that team only ->show
      // const teamIds = JSON.parse(localStorage.getItem('teamIds'));
      // query = query.in('userId', teamIds);
      // ??This user access is going to be given only to CRM user
      query = query.is("requestpendingwithuserid", null);
      if (repriceUnit?.value === "Pending") {
        query = query.eq("unitpricealreadyupdated", false);
      } else {
        query = query.eq("unitpricealreadyupdated", true);
      }
    } else {
      // ! show all cancellation requests
    }
  }

  if (checked && checked.length > 0) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      }
    });
  }

  // return

  if (all_cpId.length !== 0) {
    query = query.in("cpid", all_cpId);
  }

  if (
    selectedDate?.[0]?.value !== "" &&
    selectedDate?.[1]?.value !== "" &&
    selectedDate !== undefined
  ) {
    query = query
      .lte("created_at", Date.parse(new Date(selectedDate?.[1]?.value)))
      .gte("created_at", Date.parse(new Date(selectedDate?.[0]?.value)));
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.in("userid", all_salesRepresentativeId);
  }

  if (all_projectId.length !== 0) {
    if (all_projectId[0]?.[0]?.["p"]?.length > 0) {
      query = query.in("currentprojectid", all_projectId[0]?.[0]?.["p"]);
    }

    if (all_projectId[0]?.[0]?.["w"]?.length > 0) {
      query = query.in("currentwingid", all_projectId[0]?.[0]?.["w"]);
    }

    if (all_projectId[0]?.[0]?.["f"]?.length > 0) {
      query = query.in("currentfloorno", all_projectId[0]?.[0]?.["f"]);
    }
  }

  if (all_status.length !== 0) {
    // let str = [];
    // if (all_status.includes("Pending")) {
    //   // query = query.eq('paidamount', 0);
    //   str.push(`paidamount.eq.0`);
    // }
    // if (all_status.includes("Partial")) {
    //   // query = query.gt('paidamount', 0).lt('paidamount', 500000);
    //   // str = str + `paidamount.lt.500000,paidamount.gt.0`
    //   str.push(`and(paidamount.lt.500000,paidamount.gt.0)`);
    // }
    // if (all_status.includes("Complete")) {
    //   // query = query.eq('paidamount', 500000);
    //   str.push(`paidamount.eq.500000`);
    //   // str = str + `paidamount.eq.500000`
    // }
    // if (str.length) query = query.or(str.join(","));

    query = query.in("status", all_status);
  }

  const { data, count, error } = await query;
  if (error) throw error;

  if (data && data.length > 0) {
    // ✅ fetch isCommercial/gstPercentage for the current unit so the Reprice
    // modal applies the same commercial GST rule used on the cancel-unit path
    const projectIds = [...new Set(data.map((d) => d.currentprojectid).filter(Boolean))];
    const unitIds = [...new Set(data.map((d) => d.currentunitid).filter(Boolean))];

    const { data: inventoryData, error: inventoryError } = unitIds.length
      ? await supabase
          .from("Inventory")
          .select("unitId, inventoryTypeId")
          .in("unitId", unitIds)
      : { data: [], error: null };

    if (inventoryError) throw inventoryError;

    const inventoryTypeMap = new Map(
      (inventoryData || []).map((inv) => [inv.unitId, inv.inventoryTypeId])
    );

    const { data: configData, error: configError } = projectIds.length
      ? await supabase
          .from("projectAdditionalConfiguration")
          .select("projectId, wingId, inventoryTypeId, isCommercial, gstPercentage")
          .in("projectId", projectIds)
      : { data: [], error: null };

    if (configError) throw configError;

    const configMap = new Map(
      (configData || []).map((c) => [
        `${c.projectId}-${c.wingId}-${c.inventoryTypeId}`,
        { isCommercial: c.isCommercial, gstPercentage: c.gstPercentage },
      ])
    );

    const mergedData = data.map((item) => {
      const inventoryTypeId = inventoryTypeMap.get(item.currentunitid);
      const config = configMap.get(
        `${item.currentprojectid}-${item.currentwingid}-${inventoryTypeId}`
      );
      return {
        ...item,
        isCommercial: config?.isCommercial ?? null,
        gstPercentage: config?.isCommercial ? config?.gstPercentage ?? null : null,
      };
    });

    return { data: mergedData, count };
  } else {
    return { data: [], count: 0 };
  }
}

// ??Update Cancel unit requests
async function updateChangeRequests(changeUnitRequestId, status) {
  const { data, error, count } = await supabase
    .from("ChangeUnitRequests")
    .update({ status: status })
    .eq("changeUnitRequestId", changeUnitRequestId);
  if (data) return { data, count };
  else throw error;
}

//*Events-Token-refund
async function getAllEventsTokenRefundRequests(
  eventId,
  page,
  filterBy,
  search,
  userId
) {
  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  let query;
  query = supabase
    .from("TokenRefundRequests")
    .select("*,paymentId(*,leadId(*,personId(*))),userId(*)", {
      count: "exact",
    })
    .eq("paymentId.eventId", eventId);
  // !!Removed range since getting all TokenRefundRequest need to filter those in event refund request tab
  // .range(page === 0 ? page * 10 : page * 10 + 1, page === 0 ? ((page + 1) * 10) : (page * 10 + 10))
  //    if (filterBy.includes('Oldest')){
  //   query = query.order('last_updated_at', { ascending: (filterBy.includes('Oldest')) ? true : false })
  // }
  if (search && search !== "") {
    query = query.ilike(
      "paymentId.leadId.personId.name",
      `%${search}%`.toString()
    );
  }
  // !!Not need as This is on tab Access
  // if (loggedInUser?.roleId?.level !== 1) {
  //   query = query.eq('userId.userId', userId)
  // }
  const { data, count, error } = await query;
  if (data) return { data, count };
  else throw error;
}
// ??For Refunding the bulk tokens without requesting
async function getAllTokensByEvent(eventId, page, filterBy, search, userId) {
  console.log({ filterBy });

  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  let query;
  query = supabase
    .from("EventTokenLeadRelations")
    .select("*,leadId(*,personId(*)),eventTokenId(*,tokenId(*))", {
      count: "exact",
    })
    .eq("eventId", eventId)
    .eq("status", "active")
    .eq("eventTokenId.tokenId.isRefundable", true);
  if (search && search !== "") {
    query = query.ilike("leadId.personId.name", `%${search}%`.toString());
  }

  const { data, count, error } = await query;
  if (data) return { data, count };
  else throw error;
}
// ??Token Refund Update
async function updateRefundToken(tokenRefundRequestId, status) {
  const { data, error } = await supabase
    .from("TokenRefundRequests")
    .update({ status: status })
    .eq("tokenRefundRequestId", tokenRefundRequestId);
  if (data) return data;
  else throw error;
}
async function getSMForHoldUnit(unitId, leadId, inventoryMergeId) {
  let query = supabase
    .from("AllotmentPayment")
    .select("userId(name)")
    .eq("leadId", leadId)
    .eq("status", "Payment Pending");
  if (inventoryMergeId) query = query.eq("inventoryMergeId", inventoryMergeId);
  else query = query.eq("unitId", unitId);

  const { data, error } = await query;
  if (data) return data;
  else throw error;
}
async function getSpecificEventsTokenRefundRequests(paymentId) {
  let query;
  query = supabase
    .from("TokenRefundRequests")
    .select("*", { count: "exact" })
    .eq("paymentId", paymentId);

  const { data, count, error } = await query;
  if (data) return { data, count };
  else throw error;
}
async function updateInventorForChangeUnit(unitId) {
  let statusId = await getAvailableIdInventoryStatus();
  const { data, error, count } = await supabase
    .from("Inventory")
    .update({
      leadId: null,
      inventoryStatusId: statusId.data.inventoryStatusId,
    })
    .eq("unitId", unitId);
  if (data) return { data, count };
  else throw error;
}

// Freed (old) unit on a unit-shift accept: release it AND zero its costing so it
// enters the reprice queue. Only ever call this for the currentUnitId being freed on
// accept -- never for a requested unit being released back on reject (that must keep
// its real price).
async function freeAndZeroInventoryForChangeUnit(unitId) {
  let statusId = await getAvailableIdInventoryStatus();
  const { data, error, count } = await supabase
    .from("Inventory")
    .update({
      leadId: null,
      inventoryStatusId: statusId.data.inventoryStatusId,
      BSP: 0,
      GST: 0,
      SDR: 0,
      totalCost: 0,
    })
    .eq("unitId", unitId);
  if (data) return { data, count };
  else throw error;
}

async function updateChangeUnitRequest(
  status,
  changeUnitRequestId,
  oldPriceObj,
  unitPriceAlreadyUpdated,
  requestPendingWithUserId
) {
  const { data, error, count } = await supabase
    .from("ChangeUnitRequests")
    .update({
      status: status,
      oldUnitPrice: oldPriceObj,
      unitPriceAlreadyUpdated: unitPriceAlreadyUpdated,
      requestPendingWithUserId: requestPendingWithUserId,
    })
    .eq("changeUnitRequestId", changeUnitRequestId);
  if (data) return { data, count };
  else throw error;
}
async function checkForInventoryStatus(unitId) {
  const { data, error } = await supabase
    .from("Inventory")
    .select("*,inventoryStatusId(*)")
    .eq("unitId", unitId)
    .single();
  if (data) return { data };
  else throw error;
}
async function autoAdjustToken(allotmentPaymentId) {
  return new Promise((resolve, reject) => {
    // axios.post('http://192.168.2.121:8053/scheduler/adjustToken', {allotmentPaymentId}).then((resp) =>{
    axios
      .post(process.env.REACT_APP_PAYMENT_LINK_URL + "scheduler/adjustToken", {
        allotmentPaymentId,
      })
      .then((resp) => {
        console.log(
          "resp for adjust token: ",
          resp,
          " for allotment ",
          allotmentPaymentId
        );
        resolve(resp);
      })
      .catch((err) => {
        console.log(
          "error in adjust token: ",
          err,
          " for allotment ",
          allotmentPaymentId
        );
        reject(err);
      });
  });
}

// async function getFarvisionStatus() {

//   // 1️⃣ Inventory query (structure unchanged, just removed projectAdditionalConfiguration)
//   const { data: lockedUnits, error: inventoryError } = await supabase
//     .from("Inventory")
//     .select(`
//       *, 
//       unitId, 
//       inventoryTypeId,
//       projectId, 
//       Projects:projectId (
//         projectId,
//         projectName,
//         legalCharges,
//         registrationCharges
//       ), 
//       wingId(wingName), 
//       inventoryStatusId(status)
//     `);

//   if (inventoryError) throw inventoryError;

//   // 2️⃣ Filter locked units
//   const inventoryData = lockedUnits.filter(
//     u => u.inventoryStatusId?.status?.toLowerCase() === "locked"
//   );

//   if (!inventoryData || inventoryData.length === 0) {
//     return [];
//   }

//   const unitIds = [...new Set(inventoryData.map(u => u.unitId))];
//   const inventoryTypeIds = [...new Set(inventoryData.map(u => u.inventoryTypeId))];
//   const projectIds = [...new Set(inventoryData.map(u => u.projectId).filter(Boolean))];

//   // 3️⃣ Fetch Logs, Types & isCommercial separately
//   const [
//     { data: logsData, error: logsError },
//     { data: typeData, error: typeError },
//     { data: projectConfigs, error: configError }
//   ] = await Promise.all([

//     unitIds.length
//       ? supabase
//           .from("InventoryLogs")
//           .select("projectId,unitId,userId(name), holdReason, unitStatusChangeReason, created_at")
//           .in("unitId", unitIds)
//           .order("created_at", { ascending: false })
//       : { data: [], error: null },

//     inventoryTypeIds.length
//       ? supabase
//           .from("InventoryType")
//           .select("inventoryTypeId, type, created_at")
//           .in("inventoryTypeId", inventoryTypeIds)
//       : { data: [], error: null },

//     projectIds.length
//       ? supabase
//           .from("projectAdditionalConfiguration")
//           .select("projectId, isCommercial")
//           .in("projectId", projectIds)
//       : { data: [], error: null }
//   ]);

//   if (logsError) throw logsError;
//   if (typeError) throw typeError;
//   if (configError) throw configError;

//   // 4️⃣ Lookup maps
//   const logsMap = new Map();
//   (logsData || []).forEach(log => {
//     if (!logsMap.has(log.unitId)) {
//       logsMap.set(log.unitId, log);
//     }
//   });

//   const typeMap = new Map(
//     (typeData || []).map(t => [t.inventoryTypeId, t])
//   );

//   const projectConfigMap = new Map(
//     (projectConfigs || []).map(p => [p.projectId, p.isCommercial])
//   );

//   // 5️⃣ FINAL RESPONSE (STRUCTURE PRESERVED)
//   const finalData = inventoryData.map(unit => {
//     const log = logsMap.get(unit.unitId);
//     const type = typeMap.get(unit.inventoryTypeId);

//     return {
//       ...unit, // ⛔ unchanged
//       projectId: unit.projectId || null,
//       projectName: unit.Projects?.projectName || "",
//       legalCharges: unit.Projects?.legalCharges || 0,
//       registrationCharges: unit.Projects?.registrationCharges || 0,
//       wingName: unit.wingId?.wingName || "",
//       unitType: type?.type || "",
//       holdReason: log?.holdReason || "",
//       unitStatusChangeReason: log?.unitStatusChangeReason || "",
//       lastUpdatedAt: log?.created_at ?? null,

//       // ✅ injected safely (same key as before)
//       projectAdditionalConfiguration:{
//         isCommercial: projectConfigMap.get(unit.projectId) ?? null
//       },

//       userName: log?.userId?.name || ""
//     };
//   });

//   return finalData;
// }
async function getFarvisionStatus() {

  /* 1️⃣ INVENTORY (FETCH IDs CLEANLY) */
  const { data: lockedUnits, error: inventoryError } = await supabase
    .from("Inventory")
    .select(`
      *,
      unitId,
      projectId,
      wingId,
      inventoryTypeId,

      Projects:projectId (
        projectId,
        projectName,
        legalCharges,
        registrationCharges
      ),

      Wings:wingId (
        wingId,
        wingName
      ),

      inventoryStatusId(status)
    `);

  if (inventoryError) throw inventoryError;

  /* 2️⃣ FILTER LOCKED UNITS */
  const inventoryData = lockedUnits.filter(
    u => u.inventoryStatusId?.status === "Reserved"
  );

  if (!inventoryData.length) return [];

  /* 3️⃣ COLLECT IDS */
  const unitIds = [...new Set(inventoryData.map(u => u.unitId))];
  const inventoryTypeIds = [...new Set(inventoryData.map(u => u.inventoryTypeId))];
  const projectIds = [...new Set(inventoryData.map(u => u.projectId).filter(Boolean))];

  /* 4️⃣ FETCH DEPENDENT DATA */
  const [
    { data: logsData, error: logsError },
    { data: typeData, error: typeError },
    { data: projectConfigs, error: configError }
  ] = await Promise.all([

    unitIds.length
      ? supabase
          .from("InventoryLogs")
          .select(`
            projectId,
            unitId,
            userId(name),
            holdReason,
            unitStatusChangeReason,
            created_at
          `)
          .in("unitId", unitIds)
          .or("unitStatusChangeReason.ilike.%Reserved%,holdReason.not.is.null")
          .order("created_at", { ascending: false })
      : { data: [], error: null },

    inventoryTypeIds.length
      ? supabase
          .from("InventoryType")
          .select("inventoryTypeId, type")
          .in("inventoryTypeId", inventoryTypeIds)
      : { data: [], error: null },

    projectIds.length
      ? supabase
          .from("projectAdditionalConfiguration")
          .select("projectId, wingId, inventoryTypeId, isCommercial, gstPercentage")
          .in("projectId", projectIds)
      : { data: [], error: null }
  ]);

  if (logsError) throw logsError;
  if (typeError) throw typeError;
  if (configError) throw configError;

  /* 5️⃣ BUILD LOOKUP MAPS */

  // Latest log per unit (used for the "Created" date and userName).
  const logsMap = new Map();
  // Latest NON-EMPTY holdReason / unitStatusChangeReason per unit, chosen independently, so a
  // newer blank/partial log never masks an earlier real reason. (logsData is ordered
  // created_at desc, so the first non-empty hit per unit is the most recent one.)
  const holdReasonMap = new Map();
  const statusReasonMap = new Map();
  (logsData || []).forEach(log => {
    if (!logsMap.has(log.unitId)) {
      logsMap.set(log.unitId, log);
    }
    if (
      !holdReasonMap.has(log.unitId) &&
      typeof log.holdReason === "string" &&
      log.holdReason.trim() !== ""
    ) {
      holdReasonMap.set(log.unitId, log.holdReason);
    }
    if (
      !statusReasonMap.has(log.unitId) &&
      typeof log.unitStatusChangeReason === "string" &&
      log.unitStatusChangeReason.trim() !== ""
    ) {
      statusReasonMap.set(log.unitId, log.unitStatusChangeReason);
    }
  });

  // Inventory type
  const typeMap = new Map(
    (typeData || []).map(t => [t.inventoryTypeId, t.type])
  );

  // Composite config map (project + wing + type)
  const projectConfigMap = new Map(
    (projectConfigs || []).map(p => {
      const key = `${p.projectId}_${p.wingId}_${p.inventoryTypeId}`;
      return [key, { isCommercial: p.isCommercial, gstPercentage: p.gstPercentage }];
    })
  );

  /* 6️⃣ FINAL RESPONSE */
  const finalData = inventoryData.map(unit => {
    const log = logsMap.get(unit.unitId);

    const configKey = `${unit.projectId}_${unit.wingId}_${unit.inventoryTypeId}`;
    const config = projectConfigMap.get(configKey);

    return {
      ...unit,

      projectId: unit.projectId,
      projectName: unit.Projects?.projectName || "",
      legalCharges: unit.Projects?.legalCharges || 0,
      registrationCharges: unit.Projects?.registrationCharges || 0,

      wingName: unit.Wings?.wingName || "",

      unitType: typeMap.get(unit.inventoryTypeId) || "",

      holdReason: holdReasonMap.get(unit.unitId) || "",
      unitStatusChangeReason: statusReasonMap.get(unit.unitId) || "",
      lastUpdatedAt: log?.created_at ?? null,

      projectAdditionalConfiguration: {
        isCommercial: config?.isCommercial ?? null,
        // Only commercial config rows carry a GST % override; non-commercial
        // units keep using the hardcoded 1%/5% GST rule client-side
        gstPercentage: config?.isCommercial ? config?.gstPercentage ?? null : null
      },

      userName: log?.userId?.name || ""
    };
  });

  return finalData;
}



async function UpdateFarvisionStatus(unitId, updatedValues) {
  console.log("ASDFGHJ-->", unitId)
  console.log("updatedValues-->", updatedValues)
  const { data, error } = await supabase
    .from("Inventory")
    .update({
      BSP: updatedValues.bsp,
      GST: updatedValues.gst,
      SDR: updatedValues.sdr,
      totalCost: updatedValues.total
    })
    .eq("unitId", unitId);
  console.log("data123", data);

  if (error) throw error;
  return { data };
}
async function getAllProjects() {
  const { data, error } = await supabase
    .from("Projects")
    .select("projectId, projectName")
    .eq("isVJ", true)
    .order("projectName", { ascending: true });

  if (error) throw error;
  return data;
};

async function insertInventoryLog(payload) {
  const { data, error } = await supabase
    .from("InventoryLogs")
    .insert([payload]);

  if (error) {
    throw error;
  }

  return data;
};


async function UpdateInventoryStatusToAvailable(unitId) {
  const { data, error } = await supabase
    .from("InventoryStatus")
    .select("inventoryStatusId")
    .eq("status", "Available")
    .single();

  if (error || !data) {
    throw new Error("No 'Available' inventory status found.");
  }

  const availableId = data.inventoryStatusId;

  const { InventoryData, InventoryDataError } = await supabase
    .from("Inventory")
    .update({ inventoryStatusId: availableId })
    .eq("unitId", unitId);

  if (InventoryDataError) {
    console.error("Error updating inventory status:", InventoryDataError);
    throw new Error("Error updating inventory status.");
  }

  console.log("Inventory updated successfully:", InventoryData);
  return InventoryData;
}

export {
  //*add-event
  addEvent,
  getAllEvents,
  uploadEventBannerImg,
  updateEvent,
  getEvent,
  getAllTokensByEvent,

  //*Event-Details
  getEventDetailsByEventName,
  getLaunches,
  getLaunchWise,
  getEventByEventName,
  getLaunchDetails,
  //*Site-Visit
  getAllSiteVisitByEventId,

  //*Cp&Sales
  getAllCpForEvents,
  getAllUsersForEvents,
  getEventsToRepeat,

  //*DA
  AutoReleaseUnits,
  getAllUnitInterests,
  AddUnitInterest,
  getUnitStatus,
  UpdateUnitStatus,
  getInventoryStatus,
  getProjectPricingByUnitId,
  getLeadFromAllotment,
  getAllLeadNameForToken,
  getAllotedLeadFromPaymentsTable,
  getLeadData,
  InsertIntoAllotmentTable,
  allotUnit,
  RemoveUnitFromAllotment,
  getLeadForToken,
  getLaunchInventoryRelations,
  getUnitsOfLaunches,
  getUnitsOfLaunchesByWingId,
  UpdateLeadToPreviousStatus,
  updateLeadStatusForAllotment,
  getPreSelectLaunchInventoryRelations,
  getPreSelectWings,
  getPreSelectLaunches,
  getUnitsOfPreselect,
  getUnitsOfPreselectByWingName,
  AddPreSelectData,
  UpdateTokenStatus,
  getLeadFromMergedAllotment,

  //*Cancel-Unit
  getAllEventsCancelUnitRequests,
  updateCancelRequests,
  updateInventorForCancelUnit,
  updateAllotmentUnitCost,
  //*Change-Unit
  getAllEventsChangeUnitRequests,
  updateChangeRequests,
  updateChangeRequestsForReprice,
  // *Refund Token
  getAllEventsTokenRefundRequests,
  updateRefundToken,
  getSpecificEventsTokenRefundRequests,
  getEventLaunchAssignToken,
  updateCancelRequestsForRejection,
  getEventLaunch,
  //*Token-holders
  getLeadDetails,
  getAllTokenHoldersFromRpc,
  getAllotmentPaymentByUnit,
  getAllotmentDataForTokenHolders,
  // ! vedashree changes => to show sales user name on hold unit
  getSMForHoldUnit,
  startExpirePreselectCronJob,
  getAllotmentPayment,
  updateInventorForChangeUnit,
  freeAndZeroInventoryForChangeUnit,
  updateChangeUnitRequest,
  updateCancelRequestsForLeadAcceptance,
  checkForInventoryStatus,
  updateCancelRequestsForReprice,
  checkEventTokenLeadRelation,
  updatePreSelectData,
  DeleteTokenTransaction,
  updateInventorStatusWiseForCancelUnit,
  updateCancelRequestsForSkipReprice,
  updateInventorStatusWiseForCancelUnitForLeads,
  // ! auto adjust token api call
  autoAdjustToken,
  getFarvisionStatus,
  UpdateFarvisionStatus,
  getAllProjects,
  insertInventoryLog,
  UpdateInventoryStatusToAvailable

};